import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataFooterData } from 'types'
import { Modal } from 'react-bootstrap'
import ReCAPTCHA from 'react-google-recaptcha'
import { data } from 'jquery'
import { useCreateFormMutation as useSendContactFormMutationMediacore } from '@apis/mediacore/contact'
import toast from 'react-hot-toast'

const currentYear = new Date().getFullYear()

type CombinedProps = RealEstateDataFooterData

const Footer12 = ({
  global_data,
  titleHexa, //Color firma
  paragraphHexa, // Iconos color
  backgroundHexa, // Footer fondo
  backgroundColor, //Firma fondo
  socialMediaFooter, //Redes
  image, //Logo
  button,
}: CombinedProps) => {
  const getCurrentYear = () => new Date().getFullYear()
  const [sendContactFormMediacore] = useSendContactFormMutationMediacore()

  const [datos, setDatos] = useState({
    email: '',
  })

  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const handleInputChange = (event: any) => {
    setDatos({
      ...datos,
      [event.target.name]: event.target.value,
    })
  }

  useEffect(() => {
    if (!captcha) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [])

  const captcha = global_data.pageConfig.keys.captcha
  const [disabled, setDisabled] = useState(true)
  const [token, setValueToken] = useState('')
  function onChange(value: any) {
    setValueToken(value)
  }

  const sendForm = (e: { preventDefault: () => void }) => {
    e.preventDefault()
    const tags = ['Sitio Web', 'Newsletter']
    sendContactFormMediacore({
      data: { ...datos, tags, token: token },
      type: 'newsletter',
      site: global_data.id,
    })
    ;(document.getElementById('formNewsletter') as HTMLFormElement)?.reset()
    return toast.success('Te suscribiste a nuestro newsletter correctamente.')
  }

  return (
    <div
      className="footer-12"
      style={{ background: backgroundHexa || '#fff' }}
    >
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="modal-newsletter-11 p-5"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h2 className="mb-4">Suscribite a nuestro Newsletter</h2>
          <form
            onSubmit={sendForm}
            id="formNewsletter"
          >
            <input
              type="email"
              name="email"
              placeholder="E-mail*"
              onChange={handleInputChange}
              id="email"
              required
              className="w-100"
              style={{ border: '1px solid #fff', background: 'transparent', color: '#fff' }}
            />
            <div className="d-lg-flex w-100 justify-content-between mt-4 pt-2">
              {captcha ? (
                <ReCAPTCHA
                  sitekey={captcha}
                  onChange={(value) => {
                    setDisabled(false)
                    onChange(value)
                  }}
                />
              ) : (
                ''
              )}
              <button
                type="submit"
                disabled={disabled}
                className="mt-3 mt-lg-0 btn btn-white border"
              >
                SUSCRIBITE
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <footer style={{ margin: '0 auto' }}>
        <Container fluid>
          <Row className="align-items-center">
            <Col
              lg={4}
              className="justify-content-start align-items-center"
            >
              {' '}
              <img
                className="logo-footer-12 me-auto"
                src={image}
                alt="logo-footer-12"
              />
            </Col>
            <Col
              className="d-flex justify-content-center"
              lg={4}
            >
              {socialMediaFooter?.map((social, index) => (
                <a
                  href={social.link}
                  target="_blank"
                  className="social-image"
                >
                  <img
                    src={social.image}
                    alt={'social-' + index}
                    height={social.title || '30px'}
                  />
                </a>
              ))}
            </Col>
            <Col
              lg={4}
              className="d-flex justify-content-lg-end align-items-center"
            >
              <div
                onClick={() => handleShow()}
                className="ms-lg-auto btn"
                style={{
                  background: button?.backgroundColor,
                  color: button?.valueColor,
                  border: '1px solid ' + button?.borderColor,
                }}
              >
                {button?.value}
              </div>
            </Col>
          </Row>
        </Container>
        <div className="col-12 col-lg-4 d-block"></div>
      </footer>
      <div
        style={{ background: backgroundColor || '#fff' }}
        className="copy mt-auto d-flex text-center"
      >
        <p
          style={{ color: titleHexa }}
          className="text-center mx-auto"
        >
          {' '}
          Promoted by{' '}
          <a
            style={{ color: titleHexa }}
            className="mediahaus-link"
            target="_blank"
            href={global_data.content.promoted_by?.link || 'https://mediahaus.com.ar'}
          >
            {' '}
            {global_data.content.promoted_by?.label || 'MediaHaus'}{' '}
          </a>{' '}
          - Powered By{' '}
          <a
            style={{ color: titleHexa }}
            className="mediacore-link"
            href="https://mediacore.app/"
          >
            MediaCore{' '}
          </a>
          <br />{' '}
          <span
            style={{ color: titleHexa }}
            className="reservated"
          >
            Todos los derechos reservados &reg; {currentYear}{' '}
          </span>
          <br />
          <span
            style={{ color: titleHexa }}
            className="reservated"
          >
            {process.env.GATSBY_COMMIT_HASH} {' - '} {process.env.GATSBY_GIT_TAG}{' '}
          </span>
        </p>
      </div>
    </div>
  )
}

export default Footer12
